import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { UploadIcon } from '@zola/zola-ui/src/components/SvgIcons/UploadIcon';

class FileInput extends React.Component {
  constructor(props) {
    super(props);
    this.handlePhoto = this.handlePhoto.bind(this);
    this.state = {
      fileInputKey: 1,
    };
  }

  handlePhoto(e) {
    const { onSelect } = this.props;
    const file = e.target;
    if (file) {
      onSelect(file);
      this.setState({
        fileInputKey: this.state.fileInputKey + 1,
      });
    }
  }

  render() {
    const { inputId, types, filePreview, file, className, labelText } = this.props;
    const { fileInputKey } = this.state;
    const style = filePreview ? { backgroundImage: `url(${filePreview})` } : {};
    const isShowUploadText = !file.busy && !filePreview;
    return (
      <div className="file-input-container">
        <label
          htmlFor={inputId}
          className={`upload-button${filePreview ? ' has-preview' : ''}${
            file.busy ? ' uploading' : ''
          }${` ${className}` || ''}`}
          style={style}
        >
          {isShowUploadText && <UploadIcon />}
          {isShowUploadText && labelText && <span className="upload-button-text">{labelText}</span>}
        </label>
        <input
          style={{ display: 'none' }}
          type="file"
          id={inputId}
          onChange={this.handlePhoto}
          accept={types || 'image/*'}
          key={fileInputKey}
        />
      </div>
    );
  }
}

FileInput.propTypes = {
  onSelect: PropTypes.func.isRequired,
  inputId: PropTypes.string.isRequired,
  types: PropTypes.string,
  filePreview: PropTypes.string,
  file: PropTypes.shape({ busy: PropTypes.bool }),
  className: PropTypes.string,
  labelText: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => ({
  file: state.website.entities.filePreview[ownProps.inputId] || {},
});

export default connect(mapStateToProps)(FileInput);
